import React from "react";
import { Route, useRouteMatch } from "react-router-dom";
import ActionItemsPage from "./ActionItems/ActionItemsPage";
import ChecklistsPage from "./Checklists/ChecklistsPage";
import ChecklistDashboardRouter from "./ChecklistDashboard/ChecklistDashboardRouter";

const ChecklistFeaturePage = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Route path={`${path}/action-items`}>
        <ActionItemsPage />
      </Route>
      <Route path={`${path}/checklists`}>
        <ChecklistsPage />
      </Route>
      <Route path={`${path}/checklist-dashboards`}>
        <ChecklistDashboardRouter />
      </Route>
    </div>
  );
};

export default ChecklistFeaturePage;
